/* eslint no-param-reassign: "error" */

import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { requestStatusType } from '../../types';
import { getInitialState } from '../app/appSlice';

export interface GlobalSettings {
  aiChatEnabled: boolean;
}

export interface GlobalSettingsState {
  status: requestStatusType;
  data: GlobalSettings;
}

const initialState: GlobalSettingsState = {
  status: 'idle',
  data: {
    aiChatEnabled: true, // Default to enabled
  },
};

const globalSettingsSlice = createSlice({
  name: 'globalSettings',
  initialState,
  reducers: {
    setGlobalSettings: (state, action: PayloadAction<GlobalSettings>) => {
      state.data = action.payload;
      state.status = 'succeeded';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInitialState.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(getInitialState.rejected, (state) => {
        state.status = 'failed';
        // Keep default settings on failure
        state.data = {
          aiChatEnabled: true,
        };
      });
  },
});

export const { setGlobalSettings } = globalSettingsSlice.actions;
export default globalSettingsSlice.reducer;

// Selectors
export const selectGlobalSettings = (state: {
  globalSettings: GlobalSettingsState;
}) => state.globalSettings.data;
export const selectGlobalSettingsStatus = (state: {
  globalSettings: GlobalSettingsState;
}) => state.globalSettings.status;
